import { atomWithStorage } from 'jotai/utils';
import { PersonProfileFilters, DEFAULT_PERSON_PROFILE_FILTERS } from './types';

export const faceRecognitionFiltersAtom = (locationId: number) =>
  atomWithStorage<PersonProfileFilters>(
    `faceRecognition/filters/${locationId}`,
    DEFAULT_PERSON_PROFILE_FILTERS
  );

export const faceRecognitionSearchAtom = (locationId: number) =>
  atomWithStorage<string>(`faceRecognition/search/${locationId}`, '');
